import { BreadcrumbItem, Breadcrumbs } from '@/lib/Breadcrumbs';
import { TranslationKeys } from '@/localization';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type PageHeaderProps = {
  title: TranslationKeys;
  subtitle: TranslationKeys;
  breadcrumbs: BreadcrumbItem[];
  classNames?: {
    wrapper?: string;
  };
};

export const PageHeader: FC<PageHeaderProps> = ({ title, subtitle, breadcrumbs, classNames }) => {
  const { t } = useTranslation();

  return (
    <header className={twMerge('grid gap-4', classNames?.wrapper)}>
      <Breadcrumbs items={breadcrumbs} className='border-none' />
      <section className='flex flex-col gap-1 border-b border-secondary-border pb-4'>
        <h1 className='text-2xl font-semibold leading-8 text-primary-900'>{t(title as any)}</h1>
        <h3 className='text-tertiary-600'>{t(subtitle as any)}</h3>
      </section>
    </header>
  );
};
